module.exports = __webpack_public_path__ + "static/media/information.e34cd77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/information.png
// module id = 552
// module chunks = 0